export const QUESTION_TYPE = {
  1: "单选",
  2: "多选",
  3: "判断",
  4: "填空",
  5: "完型填空",
  6: "阅读理解",
  7: "简答",
};

export const QUESTION_TYPE_NAME = {
  SINGLE_CHOICE: 1,
  MULTIPLE_CHOICE: 2,
  JUDGE: 3,
  BLANK_FILL: 4,
  COMPLETE_BLANK_FILL: 5,
  READING_COMPREHENSION: 6,
  SHORT_ANSWER: 7,
};

export const QUESTION_TYPE_COLOR = {
  1: "#0FC6C2",
  2: "#CC9213",
  3: "#7EB712",
  4: "#0FC6C2",
  5: "#F754A8",
  6: "#722ED1",
  7: "#0FC6C2",
};

export const QUESTION_TYPE_BG_COLOR = {
  1: "#E8FFFB",
  2: "#FFFCE8",
  3: "#FCFFE8",
  4: "#E8FFFB",
  5: "#FFE8F1",
  6: "#F5E8FF",
  7: "#E8FFFB",
};

export const DIFFICULTY = {
  1: "易",
  2: "较易",
  3: "中",
  4: "较难",
  5: "难",
};

//1未提交 2未批改 3批改中  4已批改
export const WORK_STATUS = {
  Not_SUBMIT: 1,
  Not_CORRECTED: 2,
  CORRECTING: 3,
  CORRECTED: 4,
};

export const RATING = {
  100: "优",
  80: "良",
  60: "合格",
  40: "须努力",
};

export const RATING_COLOR = {
  100: "#F53F3F",
  80: "#FF7D00",
  60: "#00B42A",
  40: "#165DFF",
};

export const RATING_BORDER_COLOR = {
  100: "#FDCDC5",
  80: "#FFE4BA",
  60: "#AFF0B5",
  40: "#C7D3F7",
};
